// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__20LBr","detailsBorder":"styles_detailsBorder__1l21I"};